import { Typography, Box } from '@mui/material';

import Form from 'components/Form';
import { IFormRegister, IFormValues } from 'routes/Main/type';

import SectionTitle from './SectionTitle';

interface Props extends IFormRegister, IFormValues {
  disabled?: boolean;
}

const contents = [
  'Trong trường hợp của bạn, hiện tại có các điều kiện cụ thể sau đây',
];

const MethodandProcess = (props: Props) => {
  const { disabled, register } = props;

  return (
    <>
      <SectionTitle title="3. Những điều đặc biệt cần lưu ý" />
      <Box sx={{ width: '98%', margin: '48px auto 24px auto' }}>
        {contents.map((v, i) => (
          <Typography
            sx={{
              fontWeight: '400',
              fontSize: '14px',
              lineHeight: '24px',
              whiteSpace: 'pre-wrap',
            }}
          >
            {v}
          </Typography>
        ))}
        <Form.MuiTextField
          placeholder="Nhập nội dung"
          multiline
          required={false}
          minRows={3}
          disabled={disabled}
          {...register('no4')}
        />
        <Typography
          sx={{ margin: '30px 0 20px 0', fontSize: '14px', fontWeight: 500 }}
        >
          Tôi hiểu sự cần thiết của thủ tục đặt ống thông khí nội quản, phương
          pháp của thủ tục này, cũng như các biến chứng và hậu quả tiềm năng
          liên quan đến thủ tục. Do đó, tôi xin
          <br />
          chấp thuận thực hiện thủ tục này. Thêm vào đó, tôi cam kết tuân thủ
          chặt chẽ tất cả các hướng dẫn liên quan đến thủ tục và hoàn toàn hợp
          tác với các chỉ đạo và quyết định
          <br />
          của bác sĩ điều trị và người thực hiện thủ tục.
        </Typography>
      </Box>
    </>
  );
};

export default MethodandProcess;
